import { Eye, X } from 'lucide-react'
import EventPreview from '@/components/EventPreview'
import { Button } from '@/components/ui/button'
import {
  DialogClose,
  DialogContent,
  DialogDescription,
  DialogTitle,
  DialogTrigger,
} from '@/components/ui/dialog'
import type { Event } from '@/types'

export function PreviewButton() {
  return (
    <div className="pointer-events-none fixed right-4 bottom-4 z-40 sm:right-6 sm:bottom-6">
      <DialogTrigger asChild>
        <Button type="button" className="pointer-events-auto h-11 rounded-full px-4 shadow-lg shadow-primary/20">
          <Eye className="size-4" />
          Preview Listing
        </Button>
      </DialogTrigger>
    </div>
  )
}

export function PreviewDialog({
  event,
  organizationName,
  coverImagePreview,
}: {
  event: Event
  organizationName: string
  coverImagePreview: string | null
}) {
  return (
    <DialogContent
      className="max-h-[90vh] gap-0 overflow-hidden p-0 sm:max-w-4xl sm:[grid-template-rows:auto_minmax(0,1fr)]"
      showCloseButton={false}
    >
      <div className="flex items-center justify-between border-b border-black/5 bg-muted/40 px-4 py-3">
        <DialogTitle className="flex items-center gap-2 text-base font-medium text-primary">
          <Eye className="size-4" />
          Preview Listing
        </DialogTitle>
        <DialogDescription className="sr-only">Preview of how this page appears before you save it.</DialogDescription>
        <DialogClose asChild>
          <Button type="button" variant="ghost" size="icon-sm" className="rounded-full">
            <X className="size-4" />
            <span className="sr-only">Close preview</span>
          </Button>
        </DialogClose>
      </div>
      <div className="overflow-y-auto p-4">
        <EventPreview event={event} organizationName={organizationName} coverImagePreview={coverImagePreview} />
      </div>
    </DialogContent>
  )
}
